import { render, staticRenderFns } from "./printCusReceivableList.vue?vue&type=template&id=886aca40&scoped=true&"
import script from "./printCusReceivableList.vue?vue&type=script&lang=js&"
export * from "./printCusReceivableList.vue?vue&type=script&lang=js&"
import style0 from "./printCusReceivableList.vue?vue&type=style&index=0&id=886aca40&lang=less&scoped=true&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886aca40",
  null
  
)

component.options.__file = "printCusReceivableList.vue"
export default component.exports